module.exports = __webpack_public_path__ + "static/img/SM@3x.5e195582.jpg";